<!-- TopNavBar.vue -->
<script lang="ts">
import { defineComponent, computed, ref, onMounted } from 'vue'
import router from '@/router'
import logoUrl from '@/assets/logo.png'
import type { Ref } from 'vue'

import { useAuthStore } from '@/stores/auth'

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    // Extract routes from the router instance
    const routes = computed(() => {
      return router
        .getRoutes()
        .filter((route) => route.meta && route.meta.nav && route.meta.priority)
        .map((route) => ({
          name: route.name,
          path: route.path,
          meta: route.meta as { icon: string; priority: string }
        }))
        .sort((a, b) => {
          return parseInt(a.meta.priority) - parseInt(b.meta.priority)
        })
    })

    // const { username, isAuthenticated, authToken } = useAuthStore();
    const loading = ref(true)

    const iconSources: Ref<{ [key: string]: string }> = ref<{ [icon: string]: string }>({})

    const loadIconSources = async () => {
      // Ensure the icon prop is a string
      const icons = routes.value
        .filter((route) => route.meta && route.meta.icon)
        .map((route) => route.meta.icon)

      // Add some manual icons
      icons.push('user')

      const sources = await Promise.all(
        // @ts-ignore
        icons.map(async (icon: string) => {
          const response = await import(`../assets/icons/${icon}.svg`)
          return { [icon]: response.default }
        })
      )
      iconSources.value = Object.assign({}, ...sources)
    }

    // Load icon sources on component mount
    onMounted(() => {
      loadIconSources()
      if (authStore.isAuthenticated) {
        loading.value = false
        // console.log(authStore.isAuthenticated)
        // console.log(authStore.authToken)
        // console.log(authStore.username)

        // find the login route and redirect to home
        const loginRoute = routes.value.find((route) => route.name === 'Login')
        // console.log(loginRoute)
      } else {
        loading.value = false
        // console.log('isAuthenticated is false')
      }
    })

    return { routes, iconSources, logoUrl, authStore, loading }
  }
})
</script>

<template>
  <nav>
    <!-- Logo links to home -->
    <router-link to="/">
      <!-- switch on theme -->
      <img id="logo" :src="logoUrl" alt="logo" width="300" height="60" />
    </router-link>
    <div v-for="route in routes" :key="route.path" class="nav-item">
      <router-link :to="route.path">
        <span v-if="route && route.meta && route.meta.icon">
          <!-- Load icon dynamically -->
          <img class="icon" :src="iconSources[route.meta.icon]" />
        </span>
        {{ route.name }}
      </router-link>
    </div>
    <!-- Now add either the login or logout -->
    <div v-if="loading">
      <p>Loading...</p>
    </div>
    <div v-else class="nav-item">
      <!-- <router-link v-if="authStore.isAuthenticated" to="/logout">Logout</router-link> -->
      <!-- <router-link v-else to="/login">Login</router-link> -->
      <router-link
          v-if="authStore.isAuthenticated" 
          to="#" 
          @click.prevent="$emit('show-login-dialog')">
          <!-- <div class="nav-item"> -->
          <img class="icon" :src="iconSources['user']" />
          Logout
          <!-- </div> -->
      </router-link>

      <router-link 
          v-else 
          to="#" 
          @click.prevent="$emit('show-login-dialog')">
          <!-- <div class="nav-item"> -->
          <img class="icon" :src="iconSources['user']" />
          Login
          <!-- </div> -->
      </router-link>
    </div>
  </nav>
</template>

<style scoped>
nav {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

/* Pretty links */
.nav-item a, .nav-item {
  display: flex;
  align-items: center;
  padding: 2px;
  margin: 2px;
  text-decoration: none;
  /* bold */
  font-weight: bold;
  font-size: larger;
  color: var(--p-button-primary-background);
  box-sizing: border-box;
  /*  */
}

/* hover effect */
.nav-item:hover {
  /* text-decoration: underline; */
  /* text-shadow: 0 0 4px var(--p-button-primary-color); */
  /* bottom border the div */
  border-bottom: 2px solid var(--p-button-primary-background);
}
/* nav a:hover {
  color: var(--p-button-primary-color);
  background-color: var(--p-button-primary-background);
} */

.icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

/* nav a:hover {
  box-shadow: 0 0 10px var(--p-button-primary-background);
} */
</style>
